import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, isDevMode } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CheckoutConfiguration } from 'src/business/models/main-configuration.model';
import { LineItemReturnModel, OrderReturnModel } from 'src/business/services/client.generated';
import { LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { PageBase } from 'src/core-lib/navigation/base-page';
import { ComponentPage } from 'src/core-lib/navigation/models/component-page.model';
import { Page } from 'src/core-lib/navigation/models/page.interface';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { UmbracoGrid } from 'src/layout/grid/models/umbraco-grid.type';
import { StorageUtil } from 'src/utils/storage.util';
import { CheckoutPageModule } from '../../checkout-page.module';
import { BasketService } from '../../services/basket.service';



interface InvoicePage extends Page {
    uspSettings?: unknown;
    uspLayout?: unknown;
    relatedProductTags?: unknown;
    relatedProductLimit?: unknown;
}

@Component({
    selector: 'app-invoice-page',
    standalone: true,
    imports: [
        CommonModule,
        CheckoutPageModule,
    ],
    templateUrl: './invoice-page.component.html',
    styleUrls: ['./invoice-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicePageComponent extends PageBase implements ComponentPage {
    page: InvoicePage;
    order$: Promise<OrderReturnModel>;
    checkout: Partial<CheckoutConfiguration>;
    termsLayout: UmbracoGrid;
    constructor(
        private orderService: BasketService,
        private contentCache: ContentCache,
        private _detector: ChangeDetectorRef,
        private translateService: TranslateService,
        route: ActivatedRoute,
        @Inject(LANGUAGE)
        public language: string
    ) {
        super(route);
        this.getOrder();
        this.checkout = this.contentCache.get<CheckoutConfiguration>('checkout');
    }

    getOrder() {
        const currentUrl = new URL(window.location.toString());
        if (isDevMode() && !currentUrl.searchParams.has('orderId') && !currentUrl.searchParams.has('orderid'))
            this.order$ = this.orderService.get().then(_ => _.basketReturn) as Promise<OrderReturnModel>;
        else
            this.order$ = this.orderService.getOrder(currentUrl.searchParams.get('orderId') ?? currentUrl.searchParams.get('orderid') ?? '') as Promise<OrderReturnModel>;
    }

    idTrack(index: number, item: { id: string }) {
        return item.id;
    }

    addonFilter(id: string) {
        return (item: LineItemReturnModel, index: number, array: LineItemReturnModel[]) =>
            item != null &&
            'parentId' in item &&
            item.parentId === id;
    }

    parentFilter(item: LineItemReturnModel, index: number, array: LineItemReturnModel[]) {
        return item != null &&
            !('parentId' in item);
    }

    async openTerms() {
        window['terms-modal'].showModal();
        this.termsLayout = await new Promise<UmbracoGrid>(async (resolve, reject) => {
            var emptyResponse = [
                {
                    "settings": {
                        "colorTheme": {
                            "color": "#000000",
                            "backgroundColor": ""
                        },
                        "maxWidth": "1260",
                        "margin": "0",
                        "size": "size-60",
                        "tag": "H2",
                        "colorThemePost": {
                            "color": "#cc0000",
                            "backgroundColor": ""
                        },
                        "alias": "headlineSettings"
                    },
                    "text": this.translateService.instant("CHECKOUT.EMPTY_TERMS1"),
                    "textPost": this.translateService.instant("CHECKOUT.EMPTY_TERMS2"),
                    "alias": "headlineElement"
                }
            ] as UmbracoGrid;
            var checkoutData = StorageUtil.get<{ termslink: string }>('checkout');
            if (checkoutData == null || checkoutData.termslink == null)
                resolve(emptyResponse);
            let termsLink = new URL(checkoutData.termslink, window.location.origin);
            termsLink.searchParams.set('type', 'json');
            let resp = await fetch(termsLink.href).catch(e => {
                console.error(e);
                resolve(emptyResponse)
            });
            if (resp == null)
                resolve(emptyResponse);
            let data = await (resp as Response).json().catch(e => {
                console.error(e);
                resolve(emptyResponse)
            });
            if (data == null || data?.layout == null)
                resolve(emptyResponse);
            queueMicrotask(() => this._detector.markForCheck());
            resolve(data.layout as UmbracoGrid)
        })
    }
}
